import React from 'react';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function ReviewsSection() {
  const reviews = [{
    text: 'Ik zat zo vast in mijn hoofd, maar de sessies met Mark gaven me de rust en helderheid om eindelijk weer een keuze te durven maken. Een enorme opluchting.',
    author: 'Anna S.',
    focus: 'Helderheid'
  }, {
    text: 'Het weekend in de natuur was transformerend. De combinatie van de groep en de omgeving hielp me om diep te aarden en met nieuwe energie naar huis te gaan.',
    author: 'David L.',
    focus: 'Natuur & Ervaring'
  }, {
    text: 'Mark luistert zonder oordeel en helpt je om je eigen kracht te herontdekken. Ik sta nu veel zelfverzekerder in het leven en durf mijn eigen pad te volgen.',
    author: 'Eva van der Meer',
    focus: 'Zelfvertrouwen'
  }];
  return <section id="reviews" className="relative py-24 bg-night-900" data-id="element-105">
      <div className="absolute inset-0 bg-grain opacity-15 pointer-events-none mix-blend-overlay" data-id="element-106"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-107">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-108">
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-4" data-id="element-109">
            What Others Have Found
          </h2>
          <div className="h-px w-32 bg-gradient-to-r from-transparent via-gold-400 to-transparent mx-auto" data-id="element-110"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-111">
          {reviews.map((review, index) => <Card key={index} className="h-full flex flex-col bg-night-800/30" data-id="element-112">
              <div className="text-gold-400 mb-4 opacity-50" data-id="element-113">
                <Quote size={24} data-id="element-114" />
              </div>
              <p className="text-cream-50/90 italic mb-6 flex-grow leading-relaxed" data-id="element-115">
                "{review.text}"
              </p>
              <div className="mt-auto" data-id="element-116">
                <p className="text-gold-400 font-serif text-lg" data-id="element-117">
                  {review.author}
                </p>
                <p className="text-xs text-cream-50/40 uppercase tracking-wider mt-1" data-id="element-118">
                  {review.focus}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}